import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import { injectSchemaOrg, getOrganizationSchema, getWebPageSchema, getServiceSchema, getAggregateRatingSchema } from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    // Inject combined Schema.org JSON-LD
    const schemaData = {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getWebPageSchema(),
        getServiceSchema(),
        getAggregateRatingSchema()
      ]
    };
    
    injectSchemaOrg(schemaData);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Features />
      <CaseStudies />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}
